/**
 * BooleanValueSelector Component
 *
 * Provides a select dropdown for boolean field values (true/false)
 *
 * @module FilterEditor/BooleanValueSelector
 */

import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@loader/ui';

import type { ValueSelectorProps } from './types';

export const BooleanValueSelector: React.FC<ValueSelectorProps> = ({
  canEdit = true,
  filter,
  selectedField,
  debouncedOnUpdate,
}) => {
  return (
    <Select
      value={filter.value === true ? 'true' : filter.value === false ? 'false' : ''}
      onValueChange={(value) => {
        debouncedOnUpdate({
          ...filter,
          value: value === 'true',
          field_name: selectedField?.name || filter.field_name,
        });
      }}
      disabled={!filter.field_id || !canEdit}
    >
      <SelectTrigger className="bg-background w-full">
        <SelectValue placeholder="Select value" />
      </SelectTrigger>
      <SelectContent className="bg-background">
        <SelectItem value="true">True</SelectItem>
        <SelectItem value="false">False</SelectItem>
      </SelectContent>
    </Select>
  );
};
